var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestions = function SvgQuestions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#questions_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M2 14V2h12v12zm6-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-8.137a2.14 2.14 0 0 0-1.313.583 1 1 0 1 1-1.374-1.453 4.15 4.15 0 0 1 2.64-1.129C9.8 2.864 11 3.954 11 5.575a3.12 3.12 0 0 1-1.35 2.473C9.157 8.468 9 8.635 9 9a1 1 0 0 1-2 0 3.12 3.12 0 0 1 1.35-2.47c.491-.423.65-.589.65-.955 0-.194 0-.712-1-.712",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "questions_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgQuestions;